<template>
  <div class="menu-item">
    <div
      class="label"
      @click="toggleMenu"
      :style="{ paddingLeft: depth * 20 + 20 + 'px' }"
    >
      <router-link
        style="
          text-decoration: none;
          color: inherit;
          padding: 10px;
          width: 280px;
        "
        :to="{ name: route }"
        @click="click(route)"
      >
        {{ label }}
      </router-link>
      <div v-if="data" class="right">
        <i class="material-icons" :class="{ opened: expanded }">expand_more</i>
      </div>
    </div>
    <div
      v-show="showChildren"
      :class="{ 'small-menu': smallMenu }"
      class="items-container"
      :style="{ height: containerHeight }"
      ref="container"
    >
      <menu-item
        v-for="(item, index) in data"
        :key="index"
        :data="item.children"
        :label="item.label"
        :icon="item.icon"
        :depth="depth + 1"
        :smallMenu="smallMenu"
        :route="item.route"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "menu-item",
  data: () => ({
    showChildren: false,
    expanded: false,
    containerHeight: 0,
  }),
  props: {
    data: {
      type: Array,
    },
    label: {
      type: String,
    },
    icon: {
      type: String,
    },
    depth: {
      type: Number,
    },
    smallMenu: {
      type: Boolean,
    },
    route: {
      type: String,
      // required:true
    },
  },
  computed: {
    showLabel() {
      return this.smallMenu ? this.depth > 0 : true;
    },
  },
  methods: {
    toggleMenu() {
      this.expanded = !this.expanded;
      if (!this.showChildren) {
        this.showChildren = true;
        this.$nextTick(() => {
          this.containerHeight = this.$refs["container"].scrollHeight + "px";
          setTimeout(() => {
            this.containerHeight = "fit-content";
            if (navigator.userAgent.indexOf("Firefox") != -1)
              this.containerHeight = "-moz-max-content";
            this.$refs["container"].style.overflow = "visible";
          }, 300);
        });
      } else {
        this.containerHeight = this.$refs["container"].scrollHeight + "px";
        this.$refs["container"].style.overflow = "hidden";
        setTimeout(() => {
          this.containerHeight = 0 + "px";
        }, 10);
        setTimeout(() => {
          this.showChildren = false;
        }, 300);
      }
    },
  },
};
</script>

<script setup>
import { useMenuStore } from "@/stores/menu";
import { ref } from "vue";

const clicked = ref(false);
const menuStore = useMenuStore();

const click = (route) => {
  if (route != null) {
    clicked.value = true;
    menuStore.clickedMenuItem(clicked.value);
  } else {
    clicked.value = false;
    menuStore.clickedMenuItem(clicked.value);
  }
};
</script>

<style lang="scss" scoped>
.menu-item {
  position: relative;
  width: 100%;
  .label {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    white-space: nowrap;
    user-select: none;
    height: 50px;
    padding: 0 20px;
    box-sizing: border-box;
    font-size: 14px;
    color: #0065cc;
    transition: all 0.3s ease;
  }
}
.material-icons {
  font-size: 16px;
  color: #6e6e6e;
  transition: all 0.3s ease;
}
.opened {
  transform: rotate(180deg);
}
</style>
